<template>
  <div class="goods-flexble-comp" :class="[subTitle.replace(/\s+/g, '')]" >
    <!-- TODO -->
    <CaptionBar :title="title" :sub-title="subTitle" />
    <div class="goods-list-wrapper">
      <div class="goods-list c-layout">
        <div class="chevron pos-center chevron_0">
          <i></i>
        </div>
        <!-- Swiper -->
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item,index) in list" :key="index">
              <GoodsItem :item="item" :tag="tag" @addcart="handleOpenAddCartDrawer" />
            </div>
          </div>
        </div>

        <div class="chevron pos-center chevron_1">
          <i></i>
        </div>
      </div>
      <button v-if="load" class="load-goods-btn" @click="$emit('handleMoreData')">{{ $t('btns.read_more') }}</button>
    </div>
    <AddCartDrawer ref="drawer"/>
  </div>
</template>

<script>
import CaptionBar from "../CaptionBar";
import GoodsItem from "../GoodsItem";
import AddCartDrawer from '../../components/AddCardDrawer/index.vue'


export default {
  props: ["title", "subTitle", "tag", "load", "list"],
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
    initSwiper() {
      let { subTitle } = this;
      subTitle = subTitle.replace(/\s+/g, "");
      let nextEl = `.${subTitle} .chevron_1`;
      let prevEl = `.${subTitle} .chevron_0`;
      // const screemW = document.body.clientWidth || document.documentElement.clientWidth;
      setTimeout(() => {
        const swiperOption = {
          slidesPerView: 2,
          spaceBetween: 30,
          slidesPerGroup: 4,
          // loop: true,
          loopFillGroupWithBlank: true,
          navigation: {
            nextEl,
            prevEl,
          },
          breakpoints: {
            992: {
              slidesPerView: 4,
            }
          }
        };
        // if(screemW<992) {
        //   swiperOption.slidesPerView = 2;
        //   swiperOption.slidesPerGroup = 2;
        // }
        let hah = new Swiper(`.${subTitle} .swiper-container`, swiperOption);
      }, 100);
    },
    async handleOpenAddCartDrawer(pid) {
      // this.choosePid = pid;
      this.$refs.drawer.handleOpenAddCartDrawer(pid);
    },
  },
  watch: {
    list() {
      this.initSwiper();
    },
  },
  components: {
    CaptionBar,
    GoodsItem,
    AddCartDrawer
  },
};
</script>

<style lang='less'>
.goods-flexble-comp {
  .swiper-container {
    width: 100%;
    height: 100%;
  }

  margin-bottom: 45px;
  .goods-list-wrapper {
    position: relative;
    padding-top: 48px;
    .goods-list {
      display: flex;
      justify-content: space-between;
    }
    .chevron {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      z-index: 5;
      cursor: pointer;
      width: 30px;
      height: 55px;
      background: rgba(0, 0, 0, 0.267);
      i {
        width: 31px;
        height: 31px;
        background: url("~@/common/images/chevron_left-24px@2x.png") no-repeat;
        background-size: contain;
        background-position: center center;
      }
    }
    .chevron_1 {
      position: absolute;
      left: 100%;
      top: 50%;
      transform: translate(-30px, -50%);
      i {
        transform: rotate(180deg);
      }
    }
    .chevron:hover {
      background: rgba(0, 0, 0, 0.667);
    }
    .load-goods-btn {
      cursor: pointer;
      display: block;
      margin: 20px auto 48px;
      width: 125px;
      height: 40px;
      border: 1px solid var(--unnamed-color-111111);

      font-size: 16px;
      line-height: 20px;
      color: var(--unnamed-color-111111);
    }
    .load-goods-btn:hover {
      color: var(--unnamed-color-ffffff);
      background: var(---unnamed-color-ec4f00);
      border: 1px solid var(---unnamed-color-ec4f00);
    }
  }
  @media (max-width:992px) {
    .goods-list-wrapper {
      padding-top: 10px;
    }
    .goods-list {
      padding: 0 20px;
    }
    .goods-item-comp {
      width: 100%;
      .goods-img {
        width: 100%;
        height: auto;
        padding-top: calc(100%/153*191);
        position: relative;
        img {
          position: absolute;
          width: 100%;
          top: 0;
          left: 0;
        }
      }
    }
  }
}
</style>
